<template>
	<div class="filter p-3 bg-white rounded border">
		<div class="text-uppercase text-sm tracking-wide font-weight-normal cursor-pointer text-muted" @click="show=!show">
			<span class="mb-3 mr-3">
				<template v-if="selectedItems.length == 0">Filter
					 <template v-if="plusSign">+</template>
					 <template v-else>-</template>
				</template>
				<template v-else>{{ selectedItems.length }} ads selected</template>
			</span>
        </div>

		<transition name="slide" @after-enter="plusSign=false" @after-leave="plusSign=true" >
			<div v-if="show" class="mt-4">
				<div class="row">
					<div class="col-12 col-sm-6 col-xl max-xl-lg-20">
						<text-input label="Search" name="search"  v-model="search" @input="debouncedInputHandler"/>
                	</div>
					<div class="col-12 col-sm-6 col-xl max-xl-lg-20">
						<select-input label="Campaign" v-model="selectedCampaign">
							<option value="0">Choose</option>
							<option v-for="(option, index) in campaigns" :key="index" :value="option.id">
								{{ option.name }}
							</option>
						</select-input>
					</div>
					<div class="col-12 col-sm-6 col-xl max-xl-lg-20">
						<select-input label="Agreement" v-model="selectedAgreement">
							<option value="0">Choose</option>
							<option v-for="(option, index) in agreements" :key="index" :value="option.id">
								{{ option.name }}
							</option>
						</select-input>
					</div>
					<div class="col-12 col-sm-6 col-xl max-xl-lg-20">
						<select-input label="Publisher" v-model="selectedPublisher">
							<option value="0">Choose</option>
							<option v-for="(option, index) in publishers" :key="index" :value="option.id">
								{{ option.name }}
							</option>
						</select-input>
					</div>
					<div class="col-12 col-sm-6 col-xl max-xl-lg-20">
						<select-input label="Brand" v-model="selectedBrand">
							<option value="0">Choose</option>
							<option v-for="(option, index) in brands" :key="index" :value="option.id">
								{{ option.name }}
							</option>
						</select-input>
					</div>
				</div>

				<div class="mt-0 mb-3 rounded border table-responsive">
					<table class="table table-hover mb-0">
						<thead class="thead-fixed">
							<tr>
								<th class="border-top-0"></th>
								<th class="border-top-0 text-uppercase text-sm tracking-wide font-weight-normal text-muted align-middle text-nowrap">Reference</th>
								<th class="border-top-0 text-uppercase text-sm tracking-wide font-weight-normal text-muted align-middle text-nowrap">Name</th>
								<th class="border-top-0 text-uppercase text-sm tracking-wide font-weight-normal text-muted align-middle text-nowrap">Campaign</th>
								<th class="border-top-0 text-uppercase text-sm tracking-wide font-weight-normal text-muted align-middle text-nowrap">Agreement</th>
								<th class="border-top-0 text-uppercase text-sm tracking-wide font-weight-normal text-muted align-middle text-nowrap">Brand</th>
								<th class="border-top-0 text-uppercase text-sm tracking-wide font-weight-normal text-muted align-middle text-nowrap">Publisher</th>
								<th class="border-top-0 text-uppercase text-sm tracking-wide font-weight-normal text-muted align-middle text-nowrap">Placement date</th>
							</tr>
						</thead>
						<tbody>
							<template v-if="items.length > 0">
								<tr v-for="item in items" :key="item.id">
									<td class=""><input type="checkbox" :value="item.id" @change="handleChange(item.id)" :checked="isChecked(item.id)"/></td>
									<td class="text-nowrap font-weight-normal text-muted">{{ item.reference }}</td>
									<td class="text-nowrap font-weight-normal text-muted">{{ item.name }}</td>
									<td class="text-nowrap font-weight-normal text-muted">{{ item.campaign.name }}</td>
									<td class="text-nowrap font-weight-normal text-muted">{{ item.agreement.name }}</td>
									<td class="text-nowrap font-weight-normal text-muted">{{ item.brand ? item.brand.name : ''}}</td>
									<td class="text-nowrap font-weight-normal text-muted">{{ item.publisher.name }}</td>
									<td class="text-nowrap font-weight-normal text-muted">{{ item.formatted_placement_date }}</td>
								</tr>
							</template>
							<tr v-else>
								<td colspan="8" class="text-nowrap font-weight-normal text-muted text-center">No records available</td>
							</tr>
						</tbody>
					</table>
				</div>

				<div class="form-buttons">
					<button class="btn btn-primary" @click="applyFilter">Apply</button>
					<a class="btn btn-link" @click="cancelFilter">Cancel</a>
				</div>
			</div>
		</transition>

		<Modal class="text-left" title="Compare ads" :show="showModal" @close="showModal = false">
            <p>Please choose at least two ads</p>
			<button class="btn btn-primary" ref="submitRef" @click.prevent="showModal = false">Close</button>
        </Modal>
	</div>
  </template>

<script>
  import SelectInput from '../Inputs/SelectInput.vue';
  import TextInput from '../Inputs/TextInput.vue';
  import Modal from "../Modal";

  export default {
	components: {
        SelectInput,
		TextInput,
		Modal,
    },
    props: {
		campaigns: { type: Array, required: true },
        agreements: { type: Array, required: true },
        brands:  { type: Array, required: true },
        publishers:  { type: Array, required: true },
        ads: { type: Array, required: true },
    },
    data() {
      return {
        selectedCampaign: 0,
        selectedAgreement: 0,
        selectedBrand: 0,
        selectedPublisher: 0,
		filteredItems: [],
        selectedItems: [],
        items: this.ads,
		show: false,
		search: '',
		timeout: null,
		showModal: false,
		plusSign: true,
      };
    },
	watch: {
		selectedCampaign(newValue, oldValue) {
			this.loadNewAds();
		},
        selectedAgreement(newValue, oldValue) {
			this.loadNewAds();
		},
        selectedBrand(newValue, oldValue) {
			this.loadNewAds();
		},
        selectedPublisher(newValue, oldValue) {
			this.loadNewAds();
		},
	},
    methods: {
		isChecked(id) {

			return this.selectedItems.includes(id);
		},
		debouncedInputHandler() {
			if (this.timeout) {
				clearTimeout(this.timeout);
			}

			this.timeout = setTimeout(() => {
				this.loadNewAds();
			}, 500);
		},
		handleChange(id) {
			if(! this.selectedItems.includes(id)) {
				this.selectedItems.push(id);
			} else {
				this.selectedItems = this.selectedItems.filter(item => item !== id);
			}
		},
		loadNewAds() {
			const params = {
				campaign: this.selectedCampaign,
				agreement: this.selectedAgreement,
				brand: this.selectedBrand,
				publisher: this.selectedPublisher,
				selected: this.selectedItems,
				search: this.search,
			}

			axios.get('/api/compare', { params, paramsSerializer: (params) => {
				return qs.stringify(params);
			}}).then(response => {
				this.items = response.data.data;
            }).catch(() => {
                this.items = this.ads;
            });
		},
		cancelFilter() {
			this.show=false;
			this.selectedItems = this.filteredItems.map(obj => obj['id']);
		},
		applyFilter() {
			if(this.selectedItems.length == 1) {
				this.showModal = true;

				return;
			}

			this.show = false;

			this.filteredItems = this.items.filter((item) => {
				return this.selectedItems.includes(item.id);
			}).sort((a,b) => a.name.localeCompare(b.name));

			this.$emit('filtered-items', this.filteredItems);

		},
    },
};
</script>

<style scoped>
	.slide-enter-active, .slide-leave-active {
		transition: max-height .8s ease-in-out, opacity .8s ease-in-out;
	}

	.slide-enter-to,
	.slide-leave {
		opacity: 1;
		max-height: 1000px;
		overflow: hidden
	}

	.slide-enter,
	.slide-leave-to {
		opacity: 0;
		max-height: 0;
		overflow: hidden;
	}
</style>